import {GET_FEATURED_STORES, GET_PROMO_SLIDER, GET_FEATURED_ITEMS} from "./actionTypes";
import {GET_PROMO_SLIDER_URL, GET_FEATURED_STORES_API, GET_FEATURED_ITEMS_API} from "../../configs";
import Axios from "axios";

export const getPromoSlides = (lat, lng) => (dispatch) => {
	Axios.post(GET_PROMO_SLIDER_URL, {
		latitude: lat,
		longitude: lng,
	})
		.then((response) => {
			const promo_slides = response.data;
			return dispatch({ type: GET_PROMO_SLIDER, payload: promo_slides });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getFeaturedStores = (lat, lng) => (dispatch) => {
	Axios.post(GET_FEATURED_STORES_API, {
		latitude: lat,
		longitude: lng,
	})
		.then((response) => {
			const featured_stores = response.data.data;
			return dispatch({ type: GET_FEATURED_STORES, payload: featured_stores });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getFeaturedItems = (lat, lng) => (dispatch) => {
	Axios.get(`${GET_FEATURED_ITEMS_API}?latitude=${lat}&longitude=${lng}`)
		.then((response) => {
			const featured_items = response.data.data;
			return dispatch({ type: GET_FEATURED_ITEMS, payload: featured_items });
		})
		.catch(function(error) {
			console.log(error);
		});
};
